import React from 'react'

interface IcPriorityProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcPriority: React.FC<IcPriorityProps> = ({
  width = '16px',
  height = '16px',
  color = '#FD4C45',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <path
        d="M8 2.4V10.5846"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00001 14C8.44184 14 8.80001 13.6418 8.80001 13.2C8.80001 12.7582 8.44184 12.4 8.00001 12.4C7.55818 12.4 7.20001 12.7582 7.20001 13.2C7.20001 13.6418 7.55818 14 8.00001 14Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  )
}

export default IcPriority
